import { Component, OnInit } from '@angular/core';
import { urlErpApi } from '../../../../utils/apiConfig';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-documentationapi',
  templateUrl: './documentationapi.component.html',
  styleUrls: ['./documentationapi.component.scss'],
})
export class DocumentationapiComponent  implements OnInit {

  public erpUrl = urlErpApi+"/api-documentation";
  public safeErpUrl!: SafeResourceUrl;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    console.log("URL da API de Documentacao: ", this.erpUrl);
    this.safeErpUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.erpUrl);
  }

}
